import React from "react";
import Section from "../../../containers/Section";
import Header, { HeaderVariant } from "../../Header";
import Paragraph from "../../Paragraph";
import PlatformFeatureBar from "./PlatformFeatureBar";
import GradientTitle from "../../GradientTitle";

interface PlatformProps {
  title: string[];
  gradientPosition?: number;
  description: string;
  features: any;
}

const PlatformSection: React.FC<PlatformProps> = props => {
  const { title, description, features, gradientPosition } = props;

  return (
    <div className="rounded-tr-3xl bg-gradient-to-b from-blue-3-light to-white bg-opacity-40">
      <Section>
        <div className="text-center pt-20 pb-20 md:pt-24 md:pb-24">
          <div className="m-auto w-full md:max-w-2xl">
            <GradientTitle
              gradientPosition={gradientPosition}
              color="purple"
              variant={HeaderVariant.h2}
              title={title}
              lineBreak={false}
            />
            <Paragraph className="text-2xl">
              {description && description}
            </Paragraph>
          </div>
          <PlatformFeatureBar features={features} />
        </div>
      </Section>
    </div>
  );
};

export default PlatformSection;
